import React, { forwardRef, useEffect, useState } from 'react';
import './bookingSearch.scss'
import { Button, Row, Col, Form, Input } from 'antd';
import { Constant } from '../../services/services'
import { useTranslation } from 'react-i18next';
import { ClientService } from './../../services/clientService'
import { CommonService as commonService } from './../../services/commonService'
import { useGlobalState } from '../../services/state';
import BookingSelection from './bookingSelection/bookingSelection';
import { ServiceBooking, BookingData, Customer } from '../../models/appModels';
import LoadingContext from './../utils/loadingCompt/loadingContext'
import { OTPVerification } from '../../components/otpVerification/otpVerification'
import KeyPressOnlyNumeric from '../../pages/utils/validateInput';
import CustomerSelection from './../customerDetail/customerSelection/customerSelection';
import { searchBookingInitial } from '../../data/initial';
import { cloneDeep } from 'lodash';
import useSetupBooking from '../../pages/utils/useSetupBooking';
import { Rule } from 'antd/lib/form';

const layout = {
    labelCol: { span: 24 },
    wrapperCol: { span: 24 },
};

const formLayout = {
    xl: { span: 8, offset: 8 },
    lg: { span: 10, offset: 7 },
    md: { span: 12, offset: 6 },
    sm: { span: 16, offset: 4 },
    xs: { span: 22, offset: 1 }
};

const btnLayout = {
    xs: { span: 24 },
    lg: { span: 17 },
    md: { span: 18 },
    xl: { span: 16 }
};

const BookingSearch = forwardRef((props: any, ref) => {
    const { t } = useTranslation();
    const [form] = Form.useForm();
    const [, setAppointmentDetailData] = useGlobalState('appointmentDetailData');
    const [serviceDetailData, setServiceDetailData] = useGlobalState('serviceDetailData');
    const [, setJobLineData] = useGlobalState('jobLineData');
    const [, setCustomerDetailData] = useGlobalState('customerDetailData');
    const [, setVehicleDetailData] = useGlobalState('vehicleDetailData');
    const [, setOriginalVehicleMake] = useGlobalState('originalVehicleMake');
    const [bookingData, setbookingData] = useGlobalState('bookingData');
    const [, setBookingSearchDataRequest] = useGlobalState('bookingSearchDataRequest');
    const [visibleModal, setVisibleModal] = useState(false);
    const [bookingList, setBookingList] = useState<ServiceBooking[]>([]);
    const { showLoading, dismissLoading } = React.useContext(LoadingContext)
    const [dealershipId, setDealershipId] = useGlobalState('dealershipId');
    const [, setOwnedVehiclesData] = useGlobalState('ownedVehiclesData');
    const [, setBookingSearchData] = useGlobalState('bookingSearchData');
    const [makeList, setMakeList] = useGlobalState('makeList');
    const [customerType] = useGlobalState('customerType');
    const [, setCustomerPhoneNumber] = useGlobalState('customerPhoneNumber');
    const [visibleOTPVerification, setVisibleOTPVerification] = useState(false);
    const [phoneNumber, setPhoneNumber] = useState<string>("");
    const [email, setEmail] = useState<string>("");
    const [visibleCustomerModal, setVisibleCustomerModal] = useState(false);
    const [customerSearchList, setCustomerSearchList] = useState<Customer[]>([]);
    const [customerDetail, setCustomerDetail] = useGlobalState('customerDetailData');
    const isVINRequired =  process.env.REACT_APP_VIN_REQUIRED === "true";
    const isOTPVerificationByEmail =  process.env.REACT_APP_OTP_VERIFICATION_METHOD === "email";
    const [setupGlobalData] = useSetupBooking();
    const bookingLookupType = process.env.REACT_APP_BOOKING_LOOKUP || "";

    useEffect(() => {
        if (makeList == null || makeList.length == 0) {
            ClientService.getMakesByCountry(process.env.REACT_APP_COUNTRY_CODE)
                .finally(() => { })
                .then((result) => {
                    if (result) setMakeList(result.data);
                })
                .catch((error) => {
                    commonService.handleErrorResponse(error);
                });
            return () => {
                ClientService.cancelRequest();
            };
        }
    }, []);

    function searchData(enable: boolean = false) {
        const values = form.getFieldsValue();
        setCustomerPhoneNumber(values.mobileNumber);
        setBookingSearchDataRequest({
            CardRegistration: values.cardRegistration,
            MobileNumber: values.mobileNumber
        });
        if (enable) {
            showLoading();
            ClientService.searchBooking(values.cardRegistration, values.mobileNumber, dealershipId, customerType === Constant.customerTypes.Organization)
            .finally(() => dismissLoading())
            .then(res => {
                if (res) {
                    if ((res.AllBookings && res.AllBookings.length > 0) || (res.Booking && res.Booking.Appointment && (res.Booking.Id || res.Booking.DmsBookingKey))) {
                        let bookings: ServiceBooking[] = [];
                        if (res.AllBookings && res.AllBookings.length > 0) {
                            bookings = res.AllBookings;
                            if (makeList && makeList.length > 0) {
                                bookings = res.AllBookings.filter(b => b.Vehicle && (!b.Vehicle.MakeId || makeList.some(s => s.Id == b?.Vehicle?.MakeId)));
                            }
                        }
                        if (bookings && bookings.length == 0) {
                            if (!commonService.validateVehicleMakeSearch(res.Booking, makeList)) {
                                return;
                            }
                            bookings = [res.Booking];
                        }
                        setBookingList(bookings)
                        setVisibleModal(true);
                    }
                    else {
                        if (commonService.validateVehicleMakeSearch(res.Booking, makeList)) {
                            // TODO remove (TD-58557)
                            // if (res.Customers && res.Customers.length > 0) {
                            //     setupData(res, false);
                            //     setCustomerSearchList(res.Customers)
                            //     setVisibleCustomerModal(true);
                            // } else {
                            //     setupData(res);
                            // }
                            setupData(res);
                        }
                    }
                }
            })
            .catch(error => commonService.handleErrorResponse(error));
        } else setupData(searchBookingInitial, true, false)
    }

    function setupData(dataInput: BookingData, isNextStep: boolean = true, enableBookingSearch: boolean = false) {
        const data = cloneDeep(dataInput);
        if (data) {
            if (!data.Booking.Id && !data.Booking.DmsBookingId && enableBookingSearch) {
                if (!data.Booking.Customer && !data.Booking.Vehicle)
                    commonService.presentToast('info', t("customer_search.empty_booking_mes"), t("common.notification_header"))
                else
                    commonService.presentToast('info', t("customer_search.matched_vehicle_customer_mes"), t("common.notification_header"))
            }

            const formValues = form.getFieldsValue();
            const customerSearchInfo = {
                mobileNumber: formValues.mobileNumber,
                email: formValues.email,
                cardRegistration: formValues.cardRegistration,
            };
            setupGlobalData(data, customerSearchInfo);
        }
        if (isNextStep) {
            props.changeStep(Constant.bookingStep.customerDetail)
        }
    }

    const handleCancel = (objectData?: ServiceBooking) => {
        if (objectData && bookingData) {
            bookingData.Booking = objectData
            setupData(bookingData)
        }
        setVisibleModal(false)
    };

    const handleCancelOTPVerification = () => {
        setVisibleOTPVerification(false);
    }

    const handleNewBooking = (objectData: ServiceBooking) => {
        if (objectData) {
            if (objectData.Customer) {
                objectData.Customer.CustomerType = customerType ? customerType : Constant.customerTypes.Person;
                setCustomerDetailData(objectData.Customer)
            }
            else {
                let values = form.getFieldsValue();
                if (customerType === Constant.customerTypes.Organization) {
                    let obj = {
                        CustomerType: customerType,
                        ContactCustomer: { Mobile: values.mobileNumber, Email: values.email }
                    }
                    setCustomerDetailData(obj as Customer)
                } else {
                    setCustomerDetailData({ Mobile: values.mobileNumber, Email: values.email, CustomerType: customerType } as Customer)
                }
            }
            if (objectData.Vehicle) {
                if (objectData.Customer && objectData.Customer.Id == objectData.Vehicle.OwnerCustomerId) {
                    objectData.Vehicle.IsCarOwner = true
                }
                setVehicleDetailData(objectData.Vehicle)
                setOriginalVehicleMake(objectData.Vehicle.MakeId)
                setBookingSearchData({})
            }
            else {
                let values = form.getFieldsValue();
                if (values.cardRegistration) {
                    const allowVinType = [Constant.bookingLookup.ALL, Constant.bookingLookup.VIN].includes(bookingLookupType);
                    const isVin = values.cardRegistration.length === Constant.requiredVinLength;
                    setBookingSearchData({
                        IsVin: allowVinType && isVin,
                        CardRegistration: values.cardRegistration
                    })
                }
            }
            if (objectData.OwnedVehicles) {
                setOwnedVehiclesData(objectData.OwnedVehicles)
            }
        }
        setVisibleModal(false)
        props.changeStep(Constant.bookingStep.customerDetail)
    }
    const submit = () => {
        form.submit();
    }
    const openOTPValidation = () => {
        setVisibleOTPVerification(true);
    }
    const closeCustomerSelection = (obj?: Customer) => {
        setVisibleCustomerModal(false)
        setCustomerSearchList([])
        if (obj) {
            setCustomerDetail(obj)
        }
        props.changeStep(Constant.bookingStep.customerDetail)
    }

    const getCardRegistrationLabel = () => {
        switch (bookingLookupType) {
            case Constant.bookingLookup.LIC:
                return t('vehicle_detail.car_registration');
            case Constant.bookingLookup.VIN:
                return t('vehicle_detail.vin_with_hint');
            case Constant.bookingLookup.ALL:
            default:
                return t('vehicle_detail.car_registration_or_vin');
        }
    }

    const getCardRegistrationRule = (): Rule[] => {
		if (!isVINRequired) return [];

		switch (bookingLookupType) {
			case Constant.bookingLookup.LIC:
				return [
					{
						required: true,
						message: t('vehicle_detail.car_registration_required'),
					},
				];
			case Constant.bookingLookup.VIN:
				return [
					{
						required: true,
						message: t('vehicle_detail.vin_required'),
					},
					{
						validator(rule, value) {
							if (value && value.length !== Constant.requiredVinLength) {
								return Promise.reject(t('vehicle_detail.vin_invalid'));
							}
							return Promise.resolve();
						},
					},
				];
            case Constant.bookingLookup.ALL:
			default:
                return [
					{
						required: true,
						message: t('vehicle_detail.car_registration_or_vin_required'),
					},
				];
		}
	};

    return (
        <>
            <Form {...layout} form={form} name="control-hooks" onFinish={openOTPValidation}>
                <Row>
                    <Col {...formLayout}>
                        {serviceDetailData && serviceDetailData.location &&
                            <h3 className='location-container'>{`${serviceDetailData.location.DealershipName}-${serviceDetailData.location.LocationName}`}</h3>
                        }
                        <Form.Item
							name='cardRegistration'
							label={getCardRegistrationLabel()}
							labelAlign='left'
							colon={false}
							normalize={(value) => commonService.excludeSpecialCharactersInput(value)}
                            rules={getCardRegistrationRule()}
						>
							<Input />
						</Form.Item>
                        {!isOTPVerificationByEmail && (
                            <Form.Item name="mobileNumber" label={t("customer_search.mobile_number")} labelAlign="left" colon={false}
                                rules={[
                                    { required: true, message: t("customer_search.mobile_number_require_mes") },
                                    ({ getFieldValue }) => ({
                                        validator(rule, value) {
                                            if (process.env.REACT_APP_RESTRICT_PHONE_LENGTH && Number(process.env.REACT_APP_RESTRICT_PHONE_LENGTH) > 0 && value && value.length !== Number(process.env.REACT_APP_RESTRICT_PHONE_LENGTH)) {
                                                return Promise.reject(t("customer_search.mobile_number_invalid", { length: process.env.REACT_APP_RESTRICT_PHONE_LENGTH }));
                                            }
                                            return Promise.resolve();
                                        },
                                    })
                                ]}
                                normalize={value => commonService.excludeSpecialCharactersInput(value)}
                            >
                                <Input maxLength={process.env.REACT_APP_RESTRICT_PHONE_LENGTH ? Number(process.env.REACT_APP_RESTRICT_PHONE_LENGTH) : undefined} onKeyPress={KeyPressOnlyNumeric} onChange={event => { setPhoneNumber(event.target.value) }} />
                            </Form.Item>
                        )}

                        {isOTPVerificationByEmail && (
                            <Form.Item name="email" label={t("customer_search.email")} labelAlign="left" colon={false}
                                rules={[{ type: "email", message: t("customer_search.email_invalid") },
                                    { required: true, message: t("customer_search.email_required") }
                                    ]}
                                normalize={value => commonService.excludeSpecialCharactersInput(value)}
                            > 
                            <Input onChange={event => { setEmail(event.target.value) }}/>
                            </Form.Item>
                        )}
                    </Col>
                </Row>
                {
                    visibleModal &&
                    <BookingSelection handleCancel={handleCancel} bookingList={bookingList} handleNewBooking={handleNewBooking}></BookingSelection>
                }
                {
                    visibleOTPVerification &&
                    <OTPVerification email={email} phoneNumber={phoneNumber} dealershipId={dealershipId} handleCancel={handleCancelOTPVerification} handleSuccess={searchData} />
                }
                {
                    visibleCustomerModal &&
                    <CustomerSelection handleCancel={closeCustomerSelection} objectData={customerSearchList} ></CustomerSelection>
                }
            </Form>
            <Row className='custom-footer'>
                <Col {...btnLayout} className="text-right">
                    <Button type="primary" className="btn" onClick={submit}>
                        {t("common.next_label")}
                    </Button>
                </Col>
            </Row>
        </>
    );
})

export default BookingSearch